import { CORAL_DEEP, MUTED, TEXT_GRAD, CEL, CREAM, INK } from './theme.ts';
import { Icon } from './Icon.tsx';
import { rich } from './Rich.tsx';

/**
 * Eyebrow label · optional 72px icon badge · h1 (30/800, ≤2 lines, `highlight`
 * word rendered through the primary text gradient) · muted subtitle.
 */
export function TitleBlock({
  label,
  title,
  highlight,
  subtitle,
  icon,
  iconVariant = 'cream',
  top,
  popIcon = false,
}: {
  label?: string;
  title?: string;
  highlight?: string;
  subtitle?: string;
  icon?: string;
  iconVariant?: 'cream' | 'celebration';
  top?: number;
  popIcon?: boolean;
}) {
  const celebration = iconVariant === 'celebration';
  return (
    <div className="fk-title" style={{ display: 'flex', flexDirection: 'column', gap: 8, textAlign: 'center', marginTop: top ?? 'var(--fk-title-top)' }}>
      {label ? (
        <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: '.06em', textTransform: 'uppercase', color: CORAL_DEEP }}>
          {label}
        </div>
      ) : null}
      {icon ? (
        <span
          style={{
            alignSelf: 'center',
            width: 72,
            height: 72,
            borderRadius: 18,
            background: celebration ? CEL : CREAM,
            color: celebration ? '#fff' : CORAL_DEEP,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            animation: popIcon ? 'fk-pop .5s ease-out' : 'none',
          }}
        >
          <Icon name={icon} size={36} />
        </span>
      ) : null}
      {title ? (
        <h1 style={{ fontSize: 'var(--fk-h1)', fontWeight: 800, letterSpacing: '-.03em', lineHeight: 1.12, margin: 0, textWrap: 'balance' }}>
          {rich(title, CORAL_DEEP)}
          {highlight ? (
            <>
              {' '}
              <span style={{ background: TEXT_GRAD, WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>
                {highlight}
              </span>
            </>
          ) : null}
        </h1>
      ) : null}
      {subtitle ? <p style={{ margin: '0 auto', color: MUTED, fontSize: 'var(--fk-sub)', textWrap: 'balance', maxWidth: '34ch' }}>{rich(subtitle, INK)}</p> : null}
    </div>
  );
}
